<template>
  <section class="faq-accordion py-5 bg-white">
    <div class="container">
      <div class="row justify-content-center text-center mb-5">
        <div class="col-lg-8">
          <span
            class="badge badge-primary-base px-3 py-2
           text-uppercase font-weight-bold mb-2"
          >
            Preguntas Frecuentes
          </span>
          <h2 class="h1 font-weight-bold text-dark-blue mb-3">
            Aclaramos todas tus dudas sobre AMII
          </h2>
          <p class="lead text-muted">
            Transparencia total antes de dar el paso.
          </p>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-lg-9">
          <div
            id="faqAccordion"
            class="accordion"
          >
            <div
              v-for="(item, idx) in faqs"
              :key="idx"
              class="card border mb-3 rounded-lg overflow-hidden shadow-xs"
            >
              <div
                class="card-header bg-white p-3 cursor-pointer d-flex
                 align-items-center justify-content-between"
                @click="toggle(idx)"
              >
                <h3 class="h6 font-weight-bold text-dark mb-0">
                  {{ item.question }}
                </h3>
                <span class="text-primary-base font-weight-bold">
                  {{ activeIndex === idx ? '−' : '+' }}
                </span>
              </div>

              <div
                v-if="activeIndex === idx"
                class="card-body bg-light text-muted small border-top"
              >
                {{ item.answer }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FaqAccordion',
  data() {
    return {
      activeIndex: 0,
      faqs: [
        {
          question: '¿Tengo que ser experto en tecnología para usar AMII?',
          answer: 'Para nada. AMII está diseñado para ser tan intuitivo'
          + ' como usar WhatsApp. Además, nuestro equipo de soporte te'
          +' guía en la configuración de tus plantillas y formatos.',
        },
        {
          question: '¿Puedo conectar mi propio número de WhatsApp a AmiiBot?',
          answer: 'Sí. Puedes vincular tu número de atención a '
          +'pacientes mediante un código QR desde la configuración de '
          +'AMII en pocos segundos.',
        },
        {
          question: '¿Qué pasa si un paciente cancela su cita?',
          answer: 'AMII detecta la cancelación y ofrece el cupo de '
          +'inmediato a otros pacientes interesados para que no te '
          +'quedes con espacios vacíos en tu agenda.',
        },
        {
          question: '¿Están seguras las historias clínicas y datos '
          +'de mis pacientes?',
          answer: 'Totalmente. AMII cuenta con encriptación avanzada '
          +'en la nube y cumple con estrictos estándares '
          +'internacionales de privacidad médica.',
        },
      ],
    };
  },
  methods: {
    toggle(idx) {
      this.activeIndex = this.activeIndex === idx ? null : idx;
    },
  },
};
</script>

<style scoped>
.text-dark-blue {
  color: #002196;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
